import request from "@/utils/request";

export function addUser(data) {
  return request({
    url: "/UserManagement/AddUser",
    method: "post",
    data
  });
}
export function getUserList(params) {
  return request({
    url: "/UserManagement/GetUserGroupWithPaging",
    method: "get",
    params
  });
}
export function enableUser(data) {
  return request({
    url: "/UserManagement/EnableUser",
    method: "post",
    data
  });
}
export function disableUser(data) {
  return request({
    url: "/UserManagement/DisableUser",
    method: "post",
    data
  });
}
export function deleteUser(data) {
  return request({
    url: "/UserManagement/DeleteUser",
    method: "delete",
    data
  });
}
export function getUserRole(params) {
  return request({
    url: "/UserManagement/GetUserRoles",
    method: "get",
    params
  });
}
export function allocateRolesToUser(data) {
  return request({
    url: "/UserManagement/AllocateRolesToUser",
    method: "post",
    data
  });
}
